<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus, molestias tempora nemo impedit, esse exercitationem nisi, nesciunt excepturi, distinctio libero maiores ipsa aliquam ab saepe fuga nulla facilis quam quaerat!
      </v-col>
    </v-row>
  </v-container>
</template>
<script> 
// import axios from "axios";
// import Swal from "sweetalert2";

export default {
data: () => ({
     
}),

created() {
    this.dataProductPublic()
},

mounted() {
},

computed: {
    itemsProduct () {
      return this.$store.getters["category/ITEMS_PRODUCT_PUBLIC"];
    }
},

methods: {

    async dataProductPublic() {
        try {
            await this.$store.dispatch(
                "categories/INDEX_PRODUCT_PUBLIC"
            );
        } catch(e) {
            // statements
            console.log(e.response);
        }
    },
}
};
</script>